export default __webpack_public_path__ + "static/media/PusheenGame2.ec4ff931.png";